export const initialSelectedGroup = {
  data: {
    groupId: "",
    groupName: "",
    attivaNumeroMassimo: false,
    gestisciEventiDiRete: false,
    fdnGroupMemberObjectList: [],
  },
  loading: false,
};
